import serviceUsuario from '@/services/modules/seguridad/usuario'

export default {
  USUARIO_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceUsuario.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_FIND_ALL_BY_ENCUESTA(_, params) {
    return new Promise((resolve, reject) => {
      serviceUsuario.findAllByEncuesta(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_FIND_ALL_BY_INSTITUCION(_, params) {
    return new Promise((resolve, reject) => {
      serviceUsuario.findAllByInstitucion(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceUsuario.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_CREATE_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceUsuario.createAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceUsuario.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  USUARIO_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceUsuario.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
